import {BaselineValue} from './BaselineValue';

export class BaselineValueLite {
bid: number | null;
cr: number | null;
crea: string;
cv: string;
f: string;
id: number | null;
key: string;
l: number | null;
locOn: boolean;
locVals: {[key: string]: BaselineValue};
m: string;
op: string;
rn: number;
scen: string;
upd: string;
v: string;
val: string;
ver: number;
vs: string;
vsp: string;
}

